import React from 'react';
import { cn } from '@client/lib/utils';
import { hapticSelection } from '@client/lib/haptics';

interface Tab {
  id: string;
  label: string;
  icon: React.ReactNode;
  activeIcon: React.ReactNode;
}

interface TabBarProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export function TabBar({ tabs, activeTab, onTabChange }: TabBarProps) {
  const handleTabChange = (tabId: string) => {
    if (tabId !== activeTab) {
      hapticSelection();
      onTabChange(tabId);
    }
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-background border-t border-[var(--color-ios-separator)]">
      <div className="flex items-center justify-around h-[50px] pb-safe">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabChange(tab.id)}
            className={cn(
              "flex flex-col items-center justify-center min-w-[64px] py-1",
              activeTab === tab.id ? "text-primary" : "text-muted-foreground"
            )}
          >
            <span className="h-7 w-7 flex items-center justify-center">
              {activeTab === tab.id ? tab.activeIcon : tab.icon}
            </span>
            <span className="text-[12px] leading-[16px] mt-0.5">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
